const styles = new Proxy({"GradientBg":"GradientBg-9211d","GradientButton":"GradientButton-9211d","BookMeeting":"BookMeeting-9211d"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const BookMeeting = () => (
  <div className={styles.BookMeeting}>
    <h4>Book a Meeting</h4>
    <p>
      Let us know how we can help.
      <br />
      Book a free consultation now!
    </p>

    <a
      href="https://calendly.com/tamas-cursor-insight/consultation"
      target="_blank"
      rel="noreferrer"
    >
      Book Now
    </a>
  </div>
);

export default BookMeeting;
